export default __webpack_public_path__ + "static/media/Main.1f9ecd10.png";